// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1p8jt340 {
  object-fit: cover;
  min-height: 160px;
}
._1p8jt341 {
  bottom: var(--_18w76bwh);
  right: 50%;
  transform: translateX(50%);
}
._1p8jt342 {
  bottom: var(--_18w76bwh);
  right: var(--_18w76bwh);
}
._1p8jt343 {
  bottom: var(--_18w76bwh);
  left: var(--_18w76bwh);
}
@media screen and (min-width: 768px) {
  ._1p8jt340 {
    min-height: 90px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["._1p8jt340 {\n  object-fit: cover;\n  min-height: 160px;\n}\n._1p8jt341 {\n  bottom: var(--_18w76bwh);\n  right: 50%;\n  transform: translateX(50%);\n}\n._1p8jt342 {\n  bottom: var(--_18w76bwh);\n  right: var(--_18w76bwh);\n}\n._1p8jt343 {\n  bottom: var(--_18w76bwh);\n  left: var(--_18w76bwh);\n}\n@media screen and (min-width: 768px) {\n  ._1p8jt340 {\n    min-height: 90px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
